export default __webpack_public_path__ + "static/media/popup_capex_graphic.5ba666c1.jpg";